import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title
document.title = 'The Unstoppable Brain - Delete Brain Fog in 15 Minutes';
(function () {
  try {
    if ((window as any).fbq) return;
    var n: any = (window as any).fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!(window as any)._fbq) (window as any)._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    var t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    var s = document.getElementsByTagName('script')[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '2288111705033398');
    (window as any).fbq('track', 'PageView');
    // Noscript fallback
    var img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2288111705033398&ev=PageView&noscript=1';
    document.body.appendChild(img);
  } catch (e) {}
})();
render(<App data-id="element-322" />, document.getElementById('root'));